module.exports = __webpack_public_path__ + "img/p1@2x.c5cb3ac3.png";